import script from "./RiDmvHome.vue?vue&type=script&setup=true&lang=js"
export * from "./RiDmvHome.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__